import React from 'react';
import { Button } from 'react-bootstrap';
import _ from 'underscore';
import { withTranslation } from 'react-i18next';

import { ShipmentWaypointMap } from './map';
import { Marker, InfoWindow } from 'components/maps';

class ShipmentMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: null };
  }

  handleMouseOut = () => {
    this.setState({ visible: null });
  };

  handleMouseOver = (visible) => {
    this.setState({ visible });
  };

  render() {
    const { shipment, t, height, showWaypoints, waypoints, onWaypointsSelect } =
      this.props;
    const center = _.pick(shipment.origin[0], 'lat', 'lng');
    const stopMarkers = [];

    shipment.stops.forEach((stop) => {
      stopMarkers.push(
        <React.Fragment key={stop._id}>
          <Marker
            icon={{ url: `/img/stop-${stop.sequence}.png` }}
            position={stop.location[0]}
          />
          <InfoWindow position={stop.location[0]}>
            <div>{stop.location[0].address}</div>
          </InfoWindow>
        </React.Fragment>,
      );
    });

    if (shipment.driver && shipment.current) {
      const driverCoords = {
        lat: shipment.driver.coords[1],
        lng: shipment.driver.coords[0],
      };
      stopMarkers.push(
        <Marker
          key={shipment.driver._id}
          icon={{ url: '/img/working-truck.png' }}
          position={driverCoords}
        />,
      );
    }

    const enabled = showWaypoints ? t('ENABLED') : t('DISABLED');

    return (
      <div style={{ position: 'relative', height }}>
        <Button
          onClick={() => onWaypointsSelect()}
          style={{ margin: 7, zIndex: 40, position: 'absolute' }}
          bsStyle={showWaypoints ? 'success' : 'default'}
        >
          {t('WAYPOINTS_ENABLED', { enabled })}
        </Button>
        <ShipmentWaypointMap
          waypoints={waypoints}
          center={center}
          height={height}
          markers={stopMarkers}
          visibleMarker={this.state.visible}
          onMouseOver={this.handleMouseOver}
          onMouseOut={this.handleMouseOut}
        />
      </div>
    );
  }
}

export default withTranslation()(ShipmentMap);
